export const states = [
  { label: "서울", value: "A" },
  { label: "인천", value: "C" },
  { label: "경기", value: "I" },
  { label: "대전", value: "F" },
  { label: "세종", value: "Q" },
  { label: "충청", value: "N" },
  { label: "대구", value: "D" },
  { label: "경상", value: "J" },
  { label: "울산", value: "G" },
  { label: "부산", value: "B" },
  { label: "전라", value: "L" },
  { label: "광주", value: "E" },
  { label: "강원", value: "H" },
  { label: "제주", value: "P" },
];

export const states_tr = [
  { label: "서울", value: "A" },
  { label: "인천", value: "C" },
  { label: "경기", value: "I" },
  { label: "대전", value: "F" },
  { label: "충청", value: "N" },
  { label: "대구", value: "D" },
  { label: "경상", value: "J" },
  { label: "부산", value: "B" },
];

export const states_nb = [
  { label: "서울", value: "A" },
  { label: "인천", value: "C" },
  { label: "경기", value: "I" },
  { label: "대전", value: "F" },
  { label: "세종", value: "Q" },
  { label: "충청", value: "N" },
  { label: "대구", value: "D" },
  { label: "경상", value: "J" },
  { label: "울산", value: "G" },
  { label: "부산", value: "B" },
  { label: "전라", value: "L" },
  { label: "강원", value: "H" },
  { label: "제주", value: "P" },
];